export default function DocumentSchemaChangedDialogController(
  loaderService,
  ssDialogService,
  editPmDocumentDialog
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleOkClick = _handleOkClick;

  _activate();

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleOkClick($event) {
    return _closeDialog().then(() => _showEditDocumentDialog($event, {
      document: vm.document,
      settings: vm.settings,
    }));
  }

  function _activate() {
  }

  function _showEditDocumentDialog($event, locals) {
    ssDialogService.dialogs.pm.editPmDocumentDialog = ssDialogService.alert(
      editPmDocumentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.editPmDocumentDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.documentSchemaChangedDialog);
  }
}

DocumentSchemaChangedDialogController.$inject = [
  'loaderService',
  'ssDialogService',
  'editPmDocumentDialog',
];
